import styled from 'styled-components';
import { Box } from '@10d/tend-ui-grid';

const Root = styled(Box) `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;

  .tend-ui-icon-root {
    font-size: 20px;
    color: ${props => props.theme.colors.gray0};
  }
`;

export { Root };
